import React, { useState, useEffect, useRef } from "react";
import { Handle, Position } from "reactflow";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const getNodeIcon = (type) => {
  switch (type) {
    case "message":
      return <i className="bi bi-chat-dots-fill text-success me-2" />;
    case "button":
      return <i className="bi bi-ui-checks-grid text-primary me-2" />;
    case "media":
      return <i className="bi bi-image-fill text-warning me-2" />;
    case "webhook":
      return <i className="bi bi-link-45deg text-danger me-2" />;
    case "condition":
      return <i className="bi bi-diagram-3-fill text-info me-2" />;
    case "delay":
      return <i className="bi bi-hourglass-split text-secondary me-2" />;
    case "start":
      return <i className="bi bi-play-circle-fill text-success me-2" />;
    default:
      return <i className="bi bi-box text-muted me-2" />;
  }
};

const EditableNode = ({ id, data, selected }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({ ...data });
  const editFormRef = useRef(null);

  useEffect(() => {
    setEditData({ ...data });
  }, [data]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (editFormRef.current && !editFormRef.current.contains(event.target)) {
        setIsEditing(false);
      }
    };

    if (isEditing) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditing]);

  const handleNodeClick = () => {
    if (selected) setIsEditing(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (data.onChange) {
      data.onChange(editData);
    }
    setIsEditing(false);
  };

  return (
    <div
      className={`editable-node ${selected ? "selected" : ""}`}
      onClick={handleNodeClick}
    >
      <Handle type="target" position={Position.Top} />
      <div className="p-2">
        <div className="d-flex align-items-center mb-1">
          {getNodeIcon(data.nodeType)}
          <strong>{data.label}</strong>
        </div>

        {isEditing ? (
          <form ref={editFormRef} onSubmit={handleSubmit}>
            <div className="mb-1">
              <input
                type="text"
                className="form-control form-control-sm"
                name="content"
                value={editData.content || ""}
                onChange={handleInputChange}
                placeholder="Enter content"
              />
            </div>
            <button className="btn btn-sm btn-success w-100" type="submit">
              Save
            </button>
          </form>
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{data.content}</Tooltip>}
          >
            <div className="node-content small text-muted">
              {data.content?.slice(0, 40) || "(empty)"}
            </div>
          </OverlayTrigger>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
};

export default EditableNode;
